exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/crm/components/screens/contact/customer-detail/work-flow/work-flow.component.scss
// module id = ../../../../../src/app/crm/components/screens/contact/customer-detail/work-flow/work-flow.component.scss
// module chunks = main